export default "__VITE_ASSET__1ae665d2__"